export default __webpack_public_path__ + "static/media/Bookshelf.15f8b430.jpg";